//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
  export class JobErrorModel extends ModelBase {
      static readonly $typeName = 'JobErrorModel';
      public errorContext: string;
      public errorValue: string;
      public key: string;
      public message: string;
      public source: string;
      public submittingEntityKey: string;
      public type: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/submission/models/JobErrorModel.ts